import { render, staticRenderFns } from "./ItemAccountForm.vue?vue&type=template&id=d9b0385e"
import script from "./ItemAccountForm.vue?vue&type=script&lang=js"
export * from "./ItemAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports